import {
    UiTrelloBoardModel,
    UiTrelloListModel,
    UiTrelloCardModel
} from "../../models";

export function mockUiTrelloBoardModel({
    id = "trello-board-1234",
    type = "uiTrelloBoard",
    locale = "en",
    content = mockUiTrelloBoardModelContent()
}: Partial<UiTrelloBoardModel> = {}): UiTrelloBoardModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiTrelloBoardModelContent = UiTrelloBoardModel["content"];

export function mockUiTrelloBoardModelContent({
    layout = "Mobile",
    ...optionals
}: Partial<UiTrelloBoardModelContent> = {}): UiTrelloBoardModelContent {
    return {
        layout,
        ...optionals
    };
}

export function mockUiTrelloListModel({
    id = "trello-list-1234",
    type = "uiTrelloList",
    locale = "en",
    content = mockUiTrelloListModelContent()
}: Partial<UiTrelloListModel> = {}): UiTrelloListModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiTrelloListModelContent = UiTrelloListModel["content"];

export function mockUiTrelloListModelContent({
    ...optionals
}: Partial<UiTrelloListModelContent> = {}): UiTrelloListModelContent {
    return {
        ...optionals
    };
}

export function mockUiTrelloCardModel({
    id = "trello-card-1234",
    type = "uiTrelloCard",
    locale = "en",
    content = mockUiTrelloCardModelContent()
}: Partial<UiTrelloCardModel> = {}): UiTrelloCardModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiTrelloCardModelContent = UiTrelloCardModel["content"];

export function mockUiTrelloCardModelContent({
    name = "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    ...optionals
}: Partial<UiTrelloCardModelContent> = {}): UiTrelloCardModelContent {
    return {
        name,
        ...optionals
    };
}
